<template>
	<h1 class="app-title">{{ title }}</h1>
</template>

<script>
	export default {
		name: 'AppTitle',
		props: ['title'],
	};
</script>
